import React, { useState, useEffect, forwardRef } from "react";

import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import instance, { getErrorMessage } from "api/definitions";

const sortListByLabel = (currentList) => {
  const newList = [...currentList].sort((a, b) => {
    return a.label.localeCompare(b.label);
  });
  return newList;
};

const SelectBlock = forwardRef((props, ref) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [block, setBlock] = useState([]);
  const [errorBlock, setErrorBlock] = useState(null);

  const handleChange = (event, newValue) => {
    setBlock(newValue);

    props.parentCallback(newValue);
  };

  useEffect(() => {
    setBlock(props.dataParentToChild);
    setErrorBlock(props.errorParentToChild);

    instance
      .get("bloco")
      .then(function (response) {
        setIsLoaded(true);
        const result = response.data;
        const blocks = [];
        result.map((item) => blocks.push({ label: item.nome, id: item.id }));
        setItems(sortListByLabel(blocks));
      })
      .catch(function (error) {
        setIsLoaded(true);
        const msg = getErrorMessage(error);
        setError(msg);
      });
  }, [props.dataParentToChild, props.errorParentToChild]);

  if (error) {
    return <div>Erro: {error}</div>;
  } else if (!isLoaded) {
    return <CircularProgress />;
  } else {
    return (
      <Autocomplete
        disableClearable
        value={block}
        onChange={handleChange}
        disablePortal
        id="block"
        options={items}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) =>
          value === undefined ||
          value === "" ||
          option.id === value.id ||
          option.nome === value.nome
        }
        noOptionsText={"Nenhum cadastrado"}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            margin="dense"
            inputRef={ref}
            error={errorBlock}
            label="Bloco"
          />
        )}
      />
    );
  }
});

export default SelectBlock;
